import { createProviderHook } from "../helpers";
import AppStateProvider, { AppStateContext } from "./provider";

const useAppState = createProviderHook(AppStateContext);

export {
    AppStateProvider,
    useAppState
}